var styles = ({
    root: {
        maxWidth: 1920,
        height: '100%',
        minHeight: '100vh',
        backgroundColor: '#f3f6f7',
        margin: '0 auto'
    }
});
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/styles.ts
// module id = 1365
// module chunks = 0